var styles = {"messages":"styles_messages__eqrAq flex list-reset","divider":"styles_divider__1QA2_","label":"styles_label__12haw flex bold center","date":"styles_date__3I8sb bold mx1"};

export default styles;
//# sourceMappingURL=styles.css.js.map
